<header class="site-header">
  <a class="logo" routerLink="/">CENTRAL SLAYERS</a>

  <nav class="site-nav">
    @for (item of navItems; track item.label) {
      @if (item.path !== null) {
        <a class="nav-link" [routerLink]="item.path" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">{{ item.label }}</a>
      } @else {
        <span class="nav-link disabled" [title]="item.label + ' — coming soon'">{{ item.label }}</span>
      }
    }
  </nav>

  @if (signedIn()) {
    <div class="search-box" role="button" tabindex="0" title="Search — coming soon">
      <lucide-icon [img]="icons.Search" size="13" />
      <span>Search</span>
    </div>

    <button type="button" class="bell-btn" title="Notifications">
      <lucide-icon [img]="icons.Bell" size="14" />
      @if (notifications() > 0) {
        <span class="badge">{{ notifications() }}</span>
      }
    </button>

    <div class="avatar-menu">
      <button type="button" class="avatar-btn" (click)="toggleMenu($event)">
        <img [src]="auth.currentUser()?.avatarUrl" [alt]="auth.currentUser()?.username">
      </button>

      @if (menuOpen()) {
        <div class="menu" (click)="$event.stopPropagation()">
          <div class="menu-user">
            <span class="menu-avatar"><img [src]="auth.currentUser()?.avatarUrl" alt=""></span>
            <span class="menu-names">
              <span class="menu-username">{{ auth.currentUser()?.username }}</span>
              <span class="menu-status">● {{ status() }}</span>
            </span>
          </div>
          <a href="#" class="menu-item" (click)="$event.preventDefault()">
            <lucide-icon [img]="icons.User" size="14" />My Profile
          </a>
          <a href="#" class="menu-item" (click)="$event.preventDefault()">
            <lucide-icon [img]="icons.Settings" size="14" />Settings
          </a>
          <a href="#" class="menu-item" (click)="$event.preventDefault()">
            <lucide-icon [img]="icons.Mail" size="14" />Messages
            @if (messages() > 0) {
              <span class="menu-badge">{{ messages() }}</span>
            }
          </a>
          <a href="#" class="menu-item" (click)="$event.preventDefault()">
            <lucide-icon [img]="icons.Bell" size="14" />Watched Threads
          </a>
          <div class="menu-rule"></div>
          <a href="#" class="menu-item signout" (click)="signOut($event)">
            <lucide-icon [img]="icons.LogOut" size="14" />Sign Out
          </a>
        </div>
      }
    </div>
  } @else {
    <span class="restricted-label">RESTRICTED AREA · AUTHENTICATE</span>
  }
</header>
